import { csatStore as e } from "./csatStore.mjs";
import { csatQueryKeys as t } from "./queryKeys.mjs";
import { useDismissCsatMutation as n } from "./useDismissCsatMutation.mjs";
import { useQueryClient as r } from "@maat/store-hooks";
import { useCallback as i } from "react";
//#region src/useCsatPromptControls.ts
var a = () => {
	let a = r(), o = n();
	return {
		promote: i((t) => e.promote(t), []),
		dismiss: i((e, t) => o.mutate({
			feature: e,
			promptId: t
		}), [o]),
		ignore: i((n) => {
			a.setQueryData(t.eligibility(n), { eligible: !1 }), e.close();
		}, [a])
	};
};
//#endregion
export { a as useCsatPromptControls };
